enum ApplicationAutomationTab {
  CalculatedVariables = 'Calculated Variables',
}

export default ApplicationAutomationTab;
